module.exports = __webpack_public_path__ + "img/w3_check_circle_dark.405f053f.png";